// Decorative wedding-vibe ornament divider
export const Flourish = ({ className = "", color = "#F0C4BC" }) => (
  <svg
    className={className}
    viewBox="0 0 240 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M0 12 H80" stroke={color} strokeWidth="1" />
    <path d="M160 12 H240" stroke={color} strokeWidth="1" />
    <path
      d="M88 12 C92 4, 100 4, 104 12 C108 20, 116 20, 120 12 C124 4, 132 4, 136 12 C140 20, 148 20, 152 12"
      stroke={color}
      strokeWidth="1"
      fill="none"
    />
    <circle cx="120" cy="12" r="2" fill={color} />
    <circle cx="84" cy="12" r="1.2" fill={color} />
    <circle cx="156" cy="12" r="1.2" fill={color} />
  </svg>
);

export default Flourish;
